import ReactDOM from "react-dom";
import { canUseDOM } from "exenv";
import { isFunction, g } from "./utils";

const Regis = {};
const gen = g.bind(null, "__COMPONENT");
const IDName = "data-g-id";
let Body = null;

function getId(el) {
  let id;
  while (el && Body !== el && !(id = el.getAttribute && el.getAttribute(IDName))) {
    el = el.parentNode;
  }
  return id || "__NOTFOUND__";
}

function handleGlobalClick(evt) {
  const el = evt.target;
  const id = getId(el);
  for (const k in Regis) {
    k !== id && Regis[k].onGlobalClick(el);
  }
}

export function register(c, ref) {
  if (canUseDOM) {
    const id = gen();
    if (Regis[id] === c) return true;
    const el = (ref && c.refs[ref]) || ReactDOM.findDOMNode(c);
    if (el && isFunction(c.onGlobalClick)) {
      el.setAttribute(IDName, id);
      Regis[id] = c;
    }
  }
}

export function unregister(c, ref) {
  delete Regis[getId((ref && c.refs[ref]) || ReactDOM.findDOMNode(c))];
}

function initialize() {
  Body = document.body;
  document.addEventListener("click", handleGlobalClick);
}

if (canUseDOM) {
  if (window.document.readyState !== "loading") {
    initialize();
  } else {
    window.addEventListener("DOMContentLoaded", initialize);
  }
}
